import React, { useState, useEffect, useCallback, useRef } from 'react';
import { resolveScheduleDateRange } from '../../../utils/utils';
import { getReport, fetchLookup, fetchPersonnelSearch } from '../../../apis/personnelApi';
import { getSiteDataByDistrictId } from '../../../apis/sitesApi';
import axiosInstance from '../../../utils/axiosConfig';
import Select from 'react-select';
import { fetchAllDistrict } from '../../../apis/districtsApi';
import { fetchAllSites } from '../../../apis/sitesApi';
import { debounce } from 'lodash';
import { toast } from 'react-toastify';
import ReportViewer from './ReportViewer';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import PdfViewer from './PDFBlobViewer';
import { DownloadExcel } from '../excel/downloadExcel/DownloadExcel';

interface FormData {
    reportType: string;
    personalID: string;
    sites: string;
    districts: string;
    StartDate: string;
    EndDate: string;
    PositionId: number | null;
    country: string;
    Type: string;
    Selections: string;
}

interface ReportState {
    personnelOptions: any[];
    districtReportData: any[];
    reportData: any[];
    siteData: any[];
    positionData: any[];
    siteReportData: any[];
    loading: boolean;
    page: number;
    hasMore: boolean;
}

const Report: React.FC = () => {
    const selectedPersonnel = useRef<any>(null);
    //  const downloadLinkRef = useRef<HTMLAnchorElement | null>(null);

    const [formData, setFormData] = useState<FormData>({
        reportType: '',
        personalID: '',
        sites: "",
        districts: '',
        StartDate: '',
        EndDate: '',
        PositionId: null,
        country: '',
        Type: '',
        Selections: ''
    });

    const [state, setState] = useState<ReportState>({
        personnelOptions: [],
        districtReportData: [],
        reportData: [],
        siteData: [],
        positionData: [],
        siteReportData: [],
        loading: false,
        page: 1,
        hasMore: true,
    });

    // const [reportData, setReportData] = useState<any>({dummy : 'dummy'});
    const [reportData, setReportData] = useState<any>(null);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [personnelData, reportDataResponse, districtDataResponse, allPosition, siteDataResponse] = await Promise.all([
                    fetchPersonnelSearch("", 2, 1, 100),
                    getReport(),
                    fetchAllDistrict(),
                    fetchLookup(),
                    fetchAllSites()
                ]);
                setState(prevState => ({
                    ...prevState,
                    // const personnelWithoutNullTermination = personnelData.data.filter((person: any) => person.doterm == null);
                    personnelOptions: mapPersonnelToOptions(personnelData?.data),
                    reportData: reportDataResponse?.data,
                    positionData: allPosition.data,
                    districtReportData: districtDataResponse?.data,
                    hasMore: personnelData?.data.length === 100,
                    siteReportData: siteDataResponse?.data,
                }));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, []);



    const mapPersonnelToOptions = (personnel: any) => {
        return personnel
            .map((person: any) => ({
                value: person.personalID,
                label: `${person.firstname || ''} ${person.lastname || ''}`.trim() || 'No Name',
                ...person
            }))
            .sort((a: any, b: any) => (a.label || '').localeCompare(b.label || '', undefined, { numeric: true }));
    };

    const sortOptions = (options: any[]) => {
        if (!options) return [];
        return [...options].sort((a, b) => (a.label || '').localeCompare(b.label || '', undefined, { numeric: true }));
    };



    const loadMorePersonnel = async (inputValue: string, isNewSearch: boolean = false) => {
        if (!state.hasMore && !isNewSearch) return;
        try {
            const searchPage = isNewSearch ? 1 : state.page;
            const personnelData = await fetchPersonnelSearch(inputValue, 2, searchPage, 100);
            if (personnelData?.data.length > 0) {
                const newOptions = mapPersonnelToOptions(personnelData.data);
                setState(prevState => ({
                    ...prevState,
                    personnelOptions: isNewSearch ? newOptions : [...prevState.personnelOptions, ...newOptions],
                    page: searchPage + 1,
                    hasMore: personnelData.data.length === 100,
                }));
            } else {
                setState(prevState => ({ ...prevState, hasMore: false }));
            }
        } catch (error) {
            console.error("Error fetching more personnel:", error);
        }
    };

    const debouncedLoadMore = useCallback(
        debounce((inputValue: string) => {
            loadMorePersonnel(inputValue, true);
        }, 300),
        []
    );

    const handleSelectChange = async (selectedOption: any, actionMeta: any) => {
        const name = actionMeta.name;
        const value = selectedOption ? selectedOption.value : (name === 'PositionId' ? null : '');

        setFormData(prevData => ({
            ...prevData,
            [name]: value,
            // a site picked under the previous district must not stay applied to the new one
            ...(name === 'districts' ? { sites: '' } : {})
        }));

        if (name === 'districts' && value) {
            try {
                const response = await getSiteDataByDistrictId(value, 1);
                setState(prevState => ({ ...prevState, siteData: response }));
            } catch (error) {
                console.error("Error fetching site data:", error);
            }
        } else if (name === 'districts' && !value) {
            setState(prevState => ({ ...prevState, siteData: [] }));
        }

        if (name === 'reportType' && value) {
            setReportData(null);
        }
    };

    const handlePersonnelChange = (selectedOption: any) => {
        setFormData(prevData => ({
            ...prevData,
            personalID: selectedOption ? selectedOption.value : ''
        }));
    };

    // const handleSubmit = async (e: React.FormEvent) => {
    //     e.preventDefault();
    //     try {
    //         setState(prevState => ({ ...prevState, loading: true }));
    //         const form = new FormData();
    //         if (formData.reportType) form.append('ReportId', formData.reportType);
    //         if (formData.personalID) form.append('PersonelId', formData.personalID);
    //         if (formData.districts) form.append('DistrictId', formData.districts);
    //         if (formData.sites) form.append('SiteId', formData.sites);
    //         if (formData.StartDate) form.append('StartDate', formData.StartDate);
    //         if (formData.EndDate) form.append('EndDate', formData.EndDate);
    //         if (formData.PositionId) form.append('PositionId', formData.PositionId.toString());
    //         if (formData.country) form.append('CountryId', formData.country);
    //         if (formData.Type) form.append('Type', formData.Type);
    //         if (formData.Selections) form.append('Selections', formData.Selections);
    //         const response = await axiosInstance.post('/Report/generate-report', form, {
    //             responseType: 'json',
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         });
    //         if (!response?.data?.data) {
    //             toast.info(response?.data?.message);
    //             return;
    //         }
    //         const files = response?.data?.data?.files;
    //         if (files && files.length > 0 && files[0]?.fileContent) {
    //             const binaryString = window.atob(files[0].fileContent);
    //             const bytes = new Uint8Array(binaryString.length);
    //             for (let i = 0; i < binaryString.length; i++) {
    //                 bytes[i] = binaryString.charCodeAt(i);
    //             }
    //             const blob = new Blob([bytes], {
    //                 type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    //             });
    //             const url = window.URL.createObjectURL(blob);
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('download', files[0]?.fileName);
    //             document.body.appendChild(link);
    //             link.click();
    //             window.URL.revokeObjectURL(url);
    //             document.body.removeChild(link);
    //         }
    //         if (response.data.data.reportData) {
    //             setReportData(response.data.data.reportData);
    //         }

    //     } catch (error) {
    //         console.error('Error generating report:', error);
    //     } finally {
    //         setState(prevState => ({ ...prevState, loading: false }));
    //         // handleClear();
    //     }
    // };



    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setState(prevState => ({ ...prevState, loading: true }));
            const form = new FormData();
            if (formData.reportType) form.append('ReportId', formData.reportType);
            if (formData.personalID) form.append('PersonelId', formData.personalID);
            if (formData.districts) form.append('DistrictId', formData.districts);
            if (formData.sites) form.append('SiteId', formData.sites);

            let startDate = formData.StartDate;
            let endDate = formData.EndDate;

            if (formData?.reportType == "2") {
                ({ startDate, endDate } = resolveScheduleDateRange(startDate, endDate));
            }

            if (startDate) form.append('StartDate', startDate);
            if (endDate) form.append('EndDate', endDate);
            if (formData.PositionId) form.append('PositionId', formData.PositionId.toString());
            if (formData.country) form.append('CountryId', formData.country);
            if (formData.Type) form.append('Type', formData.Type);
            if (formData.Selections) form.append('Selections', formData.Selections);

            if (formData.reportType == "81" && !formData.personalID && !formData.sites && !formData.districts) {
                toast.info("Please select a person, a site or a district.");
                return;
            }

            if (formData.reportType == "81") {
                // Person, site and district are each optional as long as one is set.
                // Person alone returns every assignment that person holds; site or
                // district alone returns every person assigned there, and we render
                // one time sheet per assignment.
                const scheduleParams = new URLSearchParams();
                if (formData.personalID) scheduleParams.append('personID', String(formData.personalID));
                if (formData.sites) scheduleParams.append('siteId', String(formData.sites));
                if (formData.districts) scheduleParams.append('districtId', String(formData.districts));
                const scheduleUrl = `/Schedules/get-schedules-by-person?${scheduleParams.toString()}`;
                const response = await axiosInstance.get(scheduleUrl);
                if (response?.data?.data?.length > 0) {
                    setReportData(response.data.data);
                } else {
                    toast.info(response?.data?.message);
                    return
                }
            } else {
                const response = await axiosInstance.post('/Report/generate-report', form, {
                    responseType: 'json',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                if (!response?.data?.data) {
                    // success with no data just means nothing matched -- not an error.
                    if (response?.data?.success) {
                        toast.info(response?.data?.message || "No data found");
                    } else {
                        toast.error(response?.data?.message || "No data found");
                    }
                    return;
                }

                const files = response?.data?.data?.files;
                if (files && files.length > 0) {

                    if (files.length === 1) {
                        // Single file download
                        const file = files[0];
                        const binaryString = window.atob(file.fileContent);
                        const bytes = new Uint8Array(binaryString.length);
                        for (let i = 0; i < binaryString.length; i++) {
                            bytes[i] = binaryString.charCodeAt(i);
                        }
                        const blob = new Blob([bytes], {
                            type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                        });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', file.fileName);
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(link);
                    } else {
                        const zip = new JSZip();
                        files.forEach((file: any, index: any) => {
                            const binaryString = window.atob(file.fileContent);
                            const bytes = new Uint8Array(binaryString.length);
                            for (let i = 0; i < binaryString.length; i++) {
                                bytes[i] = binaryString.charCodeAt(i);
                            }
                            zip.file(file.fileName, bytes, { binary: true });
                        });

                        const content = await zip.generateAsync({ type: "blob" });
                        saveAs(content, "report_files.zip");
                    }
                }

                if (response.data.data.reportData) {
                    if (formData.reportType == "79") {
                        await DownloadExcel(formData.reportType, response.data.data.reportData, formData);
                        setReportData(null);
                    } else {
                        setReportData(response.data.data.reportData);
                    }
                }
            }
        } catch (error) {
            console.error('Error generating report:', error);
        } finally {
            setState(prevState => ({ ...prevState, loading: false }));
            // handleClear();
        }
    };



    const handleClear = () => {
        setFormData({
            reportType: '',
            personalID: '',
            sites: "",
            districts: '',
            StartDate: '',
            EndDate: '',
            PositionId: null,
            country: '',
            Type: '',
            Selections: ''

        });
        setState(prevState => ({
            ...prevState,
            personnelOptions: [],
            siteData: [],
            page: 1,
            hasMore: true,
        }));
        setReportData(null);
        if (selectedPersonnel.current) {
            selectedPersonnel.current.clearValue();
        }
    };

    const handleDownloadExcel = async () => {
        await DownloadExcel(formData.reportType, reportData, formData);
    };

    const reportOptions = state.reportData.map((report) => ({
        value: report.id,
        label: report.name
    }));

    const districtOptions = state.districtReportData.map((district) => ({
        value: district.districtId,
        label: district.distNam
    }));

    // Once a district is selected its site list is authoritative, even when it comes
    // back empty. Keying the fallback off `siteData.length` instead meant a district
    // with no open sites (e.g. WEST BABYLON SCHOOL DISTRICT, whose only two sites both
    // carry a CLOSED date) silently listed every site in the system.
    const siteOptions = sortOptions(
        formData.districts
            ? (state?.siteData || []).map((site: any) => ({
                value: site.siteID,
                label: site.fullName,
                isClosed: !!site.closed
            }))
            : (state?.siteReportData || []).map((site: any) => ({
                value: site.siteID,
                label: site.siteName,
                isClosed: !!site.closed
            }))
    );

    // Closed sites stay selectable but read red, matching how terminated
    // personnel are flagged on the personnel table. Selected rows keep their
    // default colour so the label stays legible on the highlight background.
    const siteSelectStyles = {
        option: (base: any, props: any) => ({
            ...base,
            color: props.data?.isClosed && !props.isSelected ? 'red' : base.color
        }),
        singleValue: (base: any, props: any) => ({
            ...base,
            color: props.data?.isClosed ? 'red' : base.color
        })
    };

    const positionOptions = state.positionData.map((position) => ({
        value: position.positionId,
        label: position.position
    }));

    const countryOptions = [
        { value: '0', label: 'Both Counties' },
        { value: 'N', label: 'Nassau' },
        { value: 'S', label: 'Suffolk' }
    ];

    const typeOptions = [
        { value: '0', label: 'All Type' },
        { value: '1', label: 'Pre-k' },
        { value: '2', label: 'Childcare' },
        { value: '3', label: 'Pre-k & Childcare' }
    ];

    const selectionOptions = [
        { value: '0', label: 'All Selections' },
        { value: '1', label: 'Before' },
        { value: '2', label: 'During' },
        { value: '3', label: 'After' },
        { value: '4', label: 'Before & After' }
    ];
    return (
        <section className="DashboardPage py-3">
            <div className='reportOuter'>
                <div className="row justify-content-center mb-3 position-relative" style={{ zIndex: '999' }}>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <form onSubmit={handleSubmit} className="DistrictForm">
                            <div className="formCard p-3">
                                <div className="mb-0 row pe-lg-4 pe-md-4 pe-0 filterForm">
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Report type :</label>
                                            <Select
                                                name="reportType"
                                                value={sortOptions(state.reportData?.map(r => ({ value: r.id, label: r.name })) || []).find(opt => opt.value === formData.reportType) || null}
                                                onChange={handleSelectChange}
                                                options={sortOptions(state.reportData?.map(r => ({ value: r.id, label: r.name })) || [])}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select a report type"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Personnel :</label>
                                            <Select
                                                ref={selectedPersonnel}
                                                id="personalID"
                                                name="personalID"
                                                value={state.personnelOptions?.find((option: any) => option.value === formData.personalID)}
                                                onChange={handlePersonnelChange}
                                                options={state.personnelOptions}
                                                isSearchable={true}
                                                isClearable
                                                onMenuScrollToBottom={() => loadMorePersonnel("")}
                                                onInputChange={(inputValue) => {
                                                    setState(prevState => ({ ...prevState, page: 1, hasMore: true }));
                                                    debouncedLoadMore(inputValue);
                                                }}
                                                placeholder="Select or search for Person"
                                                isLoading={state.loading}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Districts :</label>
                                            <Select
                                                name="districts"
                                                value={sortOptions(state.districtReportData?.map(d => ({ value: d.districtId, label: d.distNam })) || []).find(opt => opt.value === formData.districts) || null}
                                                onChange={handleSelectChange}
                                                options={sortOptions(state.districtReportData?.map(d => ({ value: d.districtId, label: d.distNam })) || [])}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select Districts"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Sites :</label>
                                            <Select
                                                name="sites"
                                                value={siteOptions.find(opt => opt.value === formData.sites) || null}
                                                onChange={handleSelectChange}
                                                options={siteOptions}
                                                styles={siteSelectStyles}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="All Sites"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Start Date :</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="StartDate"
                                                value={formData.StartDate}
                                                onChange={(e) => setFormData(prev => ({ ...prev, StartDate: e.target.value }))}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">End Date :</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="EndDate"
                                                value={formData.EndDate}
                                                onChange={(e) => setFormData(prev => ({ ...prev, EndDate: e.target.value }))}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Position :</label>
                                            <Select
                                                name="PositionId"
                                                value={sortOptions(state.positionData?.map(p => ({ value: p.positionId, label: p.position })) || []).find(opt => opt.value === formData.PositionId) || null}
                                                onChange={handleSelectChange}
                                                options={sortOptions(state.positionData?.map(p => ({ value: p.positionId, label: p.position })) || [])}
                                                isSearchable={true}
                                                menuPlacement="top"
                                                menuPosition="fixed"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                }}
                                                isClearable={true}
                                                placeholder="Select a position"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">County :</label>
                                            <Select
                                                name="country"
                                                menuPlacement="top"
                                                menuPosition="fixed"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                }}
                                                value={[
                                                    { value: '0', label: 'Both Counties' },
                                                    { value: 'N', label: 'Nassau' },
                                                    { value: 'S', label: 'Suffolk' }
                                                ].find(opt => opt.value === formData.country) || null}
                                                onChange={handleSelectChange}
                                                options={[
                                                    { value: '0', label: 'Both Counties' },
                                                    { value: 'N', label: 'Nassau' },
                                                    { value: 'S', label: 'Suffolk' }
                                                ]}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select County"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Type :</label>
                                            <Select
                                                name="Type"
                                                menuPlacement="top"
                                                menuPosition="fixed"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                }}
                                                value={[
                                                    { value: '0', label: 'All Type' },
                                                    { value: '1', label: 'Pre-k' },
                                                    { value: '2', label: 'Childcare' },
                                                    { value: '3', label: 'Pre-k & Childcare' }
                                                ].find(opt => opt.value === formData.Type)}
                                                onChange={handleSelectChange}
                                                options={[
                                                    { value: '0', label: 'All Type' },
                                                    { value: '1', label: 'Pre-k' },
                                                    { value: '2', label: 'Childcare' },
                                                    { value: '3', label: 'Pre-k & Childcare' }
                                                ]}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select Type"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-4 col-sm-6 col-12">
                                        <div className="mb-lg-2 mb-md-2 mb-sm-2 mb-2">
                                            <label className="form-label mb-2">Selections :</label>
                                            <Select
                                                name="Selections"
                                                menuPlacement="top"
                                                menuPosition="fixed"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                }}
                                                value={[
                                                    { value: '0', label: 'All Selections' },
                                                    { value: '1', label: 'Before' },
                                                    { value: '2', label: 'During' },
                                                    { value: '3', label: 'After' },
                                                    { value: '4', label: 'Before & After' }
                                                ].find(opt => opt.value === formData.Selections) || null}
                                                onChange={handleSelectChange}
                                                options={[
                                                    { value: '0', label: 'All Selections' },
                                                    { value: '1', label: 'Before' },
                                                    { value: '2', label: 'During' },
                                                    { value: '3', label: 'After' },
                                                    { value: '4', label: 'Before & After' }
                                                ]}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select Selections"
                                            />
                                        </div>
                                    </div>



                                </div>
                                <div className="mb-0 row">
                                    <div className='col-12 mt-0'>
                                        <hr className="w-100 mt-2 mb-3" />
                                    </div>
                                    <div className='col-12 mt-0'>
                                        <div className='d-flex align-items-center flex-lg-row flex-md-row flex-md-row flex-sm-row flex-column-reverse justify-content-end gap-lg-4 gap-md-4 gap-3'>
                                            <button type="button" className='btn btn-outline' onClick={handleClear}>Clear all</button>
                                            {/* <button type="submit" className='btn btn-primary' disabled={(!formData.reportType) || state.loading}>{state.loading ? (<span className="btnloader loader"></span>) : (<span>Submit</span>)}</button> */}
                                            {reportData && formData.reportType && (
                                                <button type="button" className="btn btn-primary" onClick={handleDownloadExcel} >
                                                    Download Excel
                                                </button>
                                            )}
                                            <button type="submit" className='btn btn-primary' disabled={(!formData.reportType) || state.loading}>{state.loading ? (<span className="btnloader loader"></span>) : (<span>Generate Report</span>)}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
                {/* {reportData ? (
                    <ReportViewer
                        reportType={'32'}
                        reportData={reportData}
                    />
                ) : (
                    <div className='w-100 text-center pdfArea'></div> 
                )}  */}
                {reportData && formData.reportType ? (
                    // <ReportViewer
                    //     reportType={formData.reportType}
                    //     reportData={reportData}
                    // />
                    <PdfViewer reportType={formData.reportType} reportData={reportData} formData={formData} />
                ) : (
                    <div className='w-100 text-center pdfArea'></div>
                )}
            </div>
        </section>
    );
};

export default Report;